// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { xBaseTheme } from "@ces/XDL/types";
import color from "@ces/XDL/Utilities/color";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

const generalStyles = css`
    & + label {
        margin-left: 0;
        margin-right: 8px;
        align-items: flex-start;
    }
    & + label::before {
        flex: 1 0 13px;
        width: 13px;
        height: 13px;
        background-color: ${color("common.ui2")};
        border-color: ${color("common.ui4")};
        margin-right: 8px;
        margin-top: 0px;
    }
    &:checked + label::after {
        width: 13px;
        height: 13px;
        left: 0;
        top: 0px;
    }
    &:focus + label::before {
        box-shadow: none;
    }
`;

const hoverStyle = css`
    &:hover:not(:disabled) + label::before,
    &:hover:checked:not(:disabled) + label::before {
        border-color: ${color("common.ui8")};
    }
    &:hover:not(:disabled) + label {
        cursor: pointer;
    }
    &:hover:checked:not(:disabled) + label::after {
        border: 1px solid ${color("common.ui8")};
    }
`;

const checkedStyle = css`
    &:checked:not(:disabled) + label::before {
        border-color: ${color("common.ui4")};
        background: ${color("common.ui2")};
    }
    &:checked + label::after {
        outline: 1px solid ${color("common.ui2")};
        outline-offset: -2px;
    }
    &:checked:not(:disabled) + label::after {
        background: ${color("primary")};
        border: 1px solid ${color("common.ui4")};
    }
`;

const disabledStyle = css`
    &:disabled + label {
        opacity: 0.33;
    }
    &:disabled + label::before {
        border-color: ${color("common.border")};
    }
    &:disabled + label::after {
        background: ${color("common.ui2", 0.33)};
    }
`;

export default {
    defaultProps: {
        mergeCss: true,
        typographyProps: {
            mergeCss: true,
            size: 12,
            weight: fontConfig.weight.regular,
            color: "text.main",
            css: css`
                letter-spacing: 0;
                line-height: 13px;
                user-select: none;
            `,
        },
        css: css`
            input {
                margin-left: 0px;
                margin-right: 0px;
                margin-top: 0px;
                width: 12px;
                height: 12px;
                display: none;
                ${generalStyles}
                ${hoverStyle}
                ${checkedStyle}
                ${disabledStyle}
            }
        `,
    },
    groupDefaultProps: {
        mergeCss: true,
        labelProps: {
            variant: "h6",
        },
        errorProps: {
            css: css`
                &:empty {
                    display: none;
                }
            `,
        },
        css: css`
            & > ${TypographyStyle as any} {
                font-size: 14px;
                font-weight: bold;
                margin-bottom: 20px;
                &:empty {
                    display: none;
                }
            }
        `,
    },
} as xBaseTheme["radio"];
